import { Skeleton } from '@/new/components/skeleton';

export function DocChronRowSkeleton() {
  return (
    <div className="w-full shadow-lg/1">
      <div className="relative z-10 rounded-lg border bg-white p-5">
        {/* Filename and type chip row */}
        <div className="mb-px flex items-start justify-between gap-4">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-48" />
          </div>
        </div>

        {/* Date/title row */}
        <div className="mt-2 flex items-center gap-2">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-6 w-64" />
        </div>

        {/* Summary */}
        <div className="mt-3 space-y-1.5">
          <Skeleton className="block h-4 w-3/4" />
        </div>
      </div>

      {/* Facts section */}
      <div className="z-10 -mt-2 rounded-b-lg border bg-gray-100 p-2 pt-4">
        <div className="flex gap-1.5 p-2 px-3 pt-1.5">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-36" />
        </div>
      </div>
    </div>
  );
}
